module.exports = __webpack_public_path__ + "images/etoro.png?9bee620444fd77758684aa5d2c56024f";